import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import CtaV2 from '../../../CtaV2'
import Text from '../../../Text'
import { $textTertiary } from '../../../../styles/colors/semantics'

function GetFasterHero({
  eyebrow,
  title,
  subtitle,
  primaryCta,
  secondaryCta,
  image
}) {
  // task #67: image is now a ResolvedImage descriptor; use .src for CSS background
  const imageSrc = image?.src || null

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          {eyebrow && (
            <div className={styles.eyebrowWrapper}>
              <Text type="heading-8" color={$textTertiary.dark}>{eyebrow}</Text>
            </div>
          )}
          {title && (
            // Single-<h1> rule (Audit A #1): the /academy hero title is the page's
            // one visible <h1>. Tag flipped <h2>→<h1>; `.title` sets `margin: 0` +
            // explicit font-size so the render is byte-identical.
            <h1 className={styles.title}>
              <SimpleBlockContent blocks={title} />
            </h1>
          )}
          {subtitle && (
            <div className={styles.subtitle}>
              <SimpleBlockContent blocks={subtitle} />
            </div>
          )}

          <div className={styles.ctaWrapper}>
            {primaryCta && <CtaV2 {...primaryCta} />}
            {secondaryCta && <CtaV2 {...secondaryCta} light />}
          </div>
        </div>

        {imageSrc && (
          <div className={styles.imageWrapper}>
            <div className={styles.heroImage} style={{ backgroundImage: `url(${imageSrc})` }} />
            <div className={styles.gridOverlay}>
              {/* eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public grid-overlay SVG (Next /public), hand-sized; not resolver-managed content media */}
              <img src="/images/team-vrs-nascar/hero-grid-overlay.svg"
                alt=""
                width={1280}
                height={640}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default GetFasterHero
